import { render, staticRenderFns } from "./US2CAAUPriceSync.vue?vue&type=template&id=594f134a"
import script from "./US2CAAUPriceSync.vue?vue&type=script&lang=js"
export * from "./US2CAAUPriceSync.vue?vue&type=script&lang=js"
import style0 from "./US2CAAUPriceSync.vue?vue&type=style&index=0&id=594f134a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports